import { customAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const minio = defineConnector({
  identifier: "minio",
  name: "MinIO",
  tagLine: "S3-compatible object storage",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  auth: (app) =>
    customAuth("awsSigV4", {
      accessKeyId: app.secret.accessKey,
      secretAccessKey: app.secret.secretKey,
      region: "us-east-1",
    }),
  steps: [
    {
      title: "Enter your MinIO details",
      items: [
        {
          kind: "url",
          label: "Server URL",
          required: true,
          placeholder: "https://minio.example.com",
          target: { kind: "configuration", field: "instanceUrl" },
          helperText: "The MinIO server API endpoint URL.",
        },
        {
          kind: "input",
          label: "Access key",
          required: true,
          target: { kind: "secrets", field: "accessKey" },
        },
        {
          kind: "input",
          label: "Secret key",
          required: true,
          target: { kind: "secrets", field: "secretKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => `${instanceUrl}/minio/health/live`,
  },
});
